export const experiences = [
  {
    organisation: "Codexprt Consultancy Pvt. Ltd.",
    logo: "/experience/codexprt_logo.jpeg",
    from: "Rajkot, Gujarat, India",
    positions: [
      {
        title: "Full Stack Web Developer",
        duration: "March 2025 - June 2025",
        content: [
          {
            text: "Leading the development of full-stack applications using MERN stack, ensuring best practices and coding standards.",
          },
          {
            text: "Staying updated with the latest industry trends and technologies to continuously improve development processes.",
          },
        ],
      },
      {
        title: "MERN Stack Developer",
        duration: "Nov 2024 - Feb 2025",
        content: [
          {
            text: "Building responsive and user-friendly web applications using ReactJS, Redux, Bootstrap and TailwindCSS.",
          },
          {
            text: "Collaborating with cross-functional teams to gather requirements and deliver high-quality software solutions.",
          },
          {
            text: "Optimizing application performance and ensuring scalability through best practices in coding and architecture.",
          },
          {
            text: "Integrating authentication and authorization mechanisms to secure web applications.",
          },
        ],
      },
      {
        title: "Web Developer",
        duration: "April 2023 - Oct 2024",
        content: [
          {
            text: "Developing and maintaining end-to-end web applications using modern frontend and backend technologies.",
          },
          {
            text: "Implementing RESTful APIs and backend services using NodeJS, ExpressJS with integration of third-party APIs and services.",
          },
          {
            text: "Managing databases such as MongoDB, MySQL, including schema design, queries, and performance tuning.",
          },
          {
            text: "Participating in code reviews, debugging, testing, and deployment to staging and production environments.",
          },
        ],
      },
      // {
      //   title: "Trainee",
      //   duration: "April 2023 - Sep 2024",
      //   content: [
      //     {
      //       text: "Learning and implementing web development technologies including HTML, CSS, JavaScript, NodeJS, ExpressJS, MongoDB and MySQL.",
      //     },
      //     {
      //       text: "Improve my problem-solving skills and coding practices through hands-on projects and challenges.",
      //     },
      //   ],
      // },
    ],
  },
];
